import React from 'react';
import { Link } from 'react-router-dom';
import { useImages } from '../context/ImageContext';
import Footer from '../components/Footer';
import BBBSeal from '../components/BBBSeal';

const HomePage: React.FC = () => {
  // Get images from context - already loaded, no flashing!
  const { getImage } = useImages();
  
  // Get all images directly from context
  const heroImage = getImage('homepageinhomemedicalalertsystempendant2.jpg');
  const howWorksImage1 = getImage('salessupportmicrosite04.webp');
  const howWorksImage2 = getImage('salessupportmicrosite06.webp');
  const howWorksImage3 = getImage('salessupportmicrosite05.webp');
  const testimonialImage = getImage('medicalalertsystemshomepagepinksweater.webp');
  const whyChooseImage1 = getImage('medicalalertsystemshomepagelowprices.webp');
  const whyChooseImage2 = getImage('medicalalertsystemshomepagedelivery.webp');
  const whyChooseImage3 = getImage('medicalalertsystemshomepagenocontract.webp');
  const blogImage1 = getImage('blog1.webp');
  const blogImage2 = getImage('fd-circle-3-text-box.jpg');
  const blogImage3 = getImage('blog-356.jpg');
  const mediaLogo1 = getImage('medicalalertsystemshomepageabc.webp');
  const mediaLogo2 = getImage('medicalalertsystemshomepagegma.webp');
  const mediaLogo3 = getImage('medicalalertsystemshomepagefrontiers.webp');
  const mediaLogo4 = getImage('medicalalertsystemshomepagefox.webp');
  const mediaLogo5 = getImage('medicalalertsystemshomepageflorida.webp');
  const mediaLogo6 = getImage('medicalalertsystemshomepagewbj.webp');
  const mediaLogo7 = getImage('medicalalertsystemshomepagela.webp');

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1 className="hero-main-title">With an Alert1 Medical Alert System, You'll Never Face an Emergency Alone</h1>
          
          <div className="hero-container">
            <div className="hero-content">
              <h2 className="hero-subtitle">Call us for our LOWEST PRICE GUARANTEE!</h2>
              <p className="hero-description">Alert1 offers in-home and mobile medical alert systems for seniors and others looking for the security and protection that a personal emergency button alarm provides. Our affordable, easy to use medical alert pendants, bracelets, and wristbands offer reliable peace of mind for you or your loved ones, 24/7/365.</p>
              <p className="hero-tagline">With Alert1, <em>you'll never face an emergency alone.</em></p>
              <Link to="/medical-alerts" className="cta-button-large">START SHOPPING NOW</Link>
            </div>
            <div className="hero-image">
              {heroImage && (
                <img 
                  src={heroImage} 
                  alt="Alert1 Medical Alert System Pendant" 
                  className="hero-device-image"
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section-new">
        <div className="container">
          <h2 className="how-works-title">How do Medical Alert Systems Work?</h2>
          <p className="how-works-subtitle">Alert1's emergency button alarms come pre-programmed. Just get it and go!</p>
          
          <div className="how-works-steps">
            <Link to="/how-it-works" className="how-works-step how-works-step-link">
              <div className="how-works-icon-circle">
                {howWorksImage1 ? (
                  <img 
                    src={howWorksImage1} 
                    alt="Press Button" 
                    className="how-works-icon-image"
                  />
                ) : (
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                    <path d="M60 40 Q50 30 45 35 L40 40 Q35 45 40 50 L45 55 Q50 60 55 55 L60 50 Q65 45 65 50 L65 70 Q70 75 75 70 L75 50 Q80 45 80 50 L80 70 Q85 75 90 70 L90 50 Q90 45 85 45 Q80 45 80 40 Q80 35 75 35 Q70 35 70 40 Q70 35 65 35 Q60 35 60 40 Z" 
                          fill="white" stroke="none"/>
                    <circle cx="45" cy="75" r="12" fill="white"/>
                  </svg>
                )}
              </div>
              <h3 className="how-works-step-title">Press Button</h3>
            </Link>
            
            <div className="how-works-connector"></div>
            
            <Link to="/how-it-works" className="how-works-step how-works-step-link">
              <div className="how-works-icon-circle">
                {howWorksImage2 ? (
                  <img 
                    src={howWorksImage2} 
                    alt="Connect" 
                    className="how-works-icon-image"
                  />
                ) : (
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                    <circle cx="60" cy="45" r="15" fill="white"/>
                    <path d="M45 60 Q60 55 75 60 L75 75 Q60 80 45 75 Z" fill="white"/>
                    <ellipse cx="50" cy="40" rx="8" ry="10" fill="white"/>
                    <ellipse cx="70" cy="40" rx="8" ry="10" fill="white"/>
                    <path d="M35 45 Q30 45 30 50 L30 55 Q30 60 35 60 L40 60" stroke="white" strokeWidth="4" fill="none"/>
                    <path d="M85 45 Q90 45 90 50 L90 55 Q90 60 85 60 L80 60" stroke="white" strokeWidth="4" fill="none"/>
                    <circle cx="52" cy="42" r="3" fill="#333"/>
                    <circle cx="68" cy="42" r="3" fill="#333"/>
                  </svg>
                )}
              </div>
              <h3 className="how-works-step-title">Connect</h3>
            </Link>
            
            <div className="how-works-connector"></div>
            
            <Link to="/how-it-works" className="how-works-step how-works-step-link">
              <div className="how-works-icon-circle">
                {howWorksImage3 ? (
                  <img 
                    src={howWorksImage3} 
                    alt="Get Help Fast" 
                    className="how-works-icon-image"
                  />
                ) : (
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                    <rect x="30" y="50" width="60" height="35" rx="5" fill="white"/>
                    <rect x="35" y="55" width="50" height="15" fill="white"/>
                    <rect x="65" y="40" width="20" height="10" rx="2" fill="white"/>
                    <circle cx="45" cy="85" r="8" fill="#666"/>
                    <circle cx="75" cy="85" r="8" fill="#666"/>
                    <path d="M60 60 L60 70 M55 65 L65 65" stroke="#d32f2f" strokeWidth="3"/>
                    <circle cx="70" cy="35" r="2" fill="#ff0" opacity="0.8"/>
                    <path d="M65 30 L70 25 L75 30" stroke="#ff0" strokeWidth="2" fill="none" opacity="0.6"/>
                  </svg>
                )}
              </div>
              <h3 className="how-works-step-title">Get Help Fast</h3>
            </Link>
          </div>
          <Link to="/how-it-works" className="how-works-details-link">
            See how it works
          </Link>
        </div>
      </section>

      {/* Featured Testimonial Section */}
      <section className="featured-testimonial-section">
        <div className="container">
          <div className="featured-testimonial-container">
            <div className="featured-testimonial-content">
              <blockquote className="featured-testimonial-quote">
                "I feel confident that when I am alone I am still protected by people who care."
              </blockquote>
              <div className="featured-testimonial-stars">
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
              </div>
              <p className="featured-testimonial-reviews">Based on 1,522 reviews</p>
              <Link to="/reviews" className="featured-testimonial-btn">SEE REVIEWS</Link>
            </div>
            <div className="featured-testimonial-image">
              <div className="featured-testimonial-image-circle">
                {testimonialImage ? (
                  <img 
                    src={testimonialImage} 
                    alt="Happy Alert1 Customer" 
                    className="featured-testimonial-img"
                  />
                ) : (
                  <img 
                    src="/images/testimonial-customer.jpg" 
                    alt="Happy Alert1 Customer" 
                    className="featured-testimonial-img"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Alert1 Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="why-choose-title">What is the Best Medical Alert System for Seniors?</h2>
          <p className="why-choose-subtitle">
            Alert1's mission is to be the best medical alert company for seniors and others seeking 24/7/365 
            protection. What should you look for when selecting a medical alert service provider?
          </p>
          
          <div className="why-choose-features">
            <div className="why-feature-card">
              <div className="why-feature-icon">
                {whyChooseImage1 ? (
                  <img 
                    src={whyChooseImage1} 
                    alt="Low Prices" 
                    className="why-feature-icon-img"
                  />
                ) : (
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                    <path d="M50 15 L50 25 M50 75 L50 85" stroke="#333" strokeWidth="3" strokeLinecap="round"/>
                    <path d="M50 25 Q35 30 35 45 Q35 55 50 55 Q65 55 65 65 Q65 75 50 75" stroke="#333" strokeWidth="3" fill="none"/>
                    <path d="M25 60 L50 85 L75 60" stroke="#4a90e2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    <rect x="22" y="55" width="56" height="8" fill="white"/>
                  </svg>
                )}
              </div>
              <h3 className="why-feature-title">Low Prices</h3>
              <p className="why-feature-description">
                Protect yourself or a loved one for less than half the price of Life Alert.<sup>1</sup> No hidden 
                fees. Free activation when you buy online. Best value in the industry.
              </p>
            </div>
            
            <div className="why-feature-card">
              <div className="why-feature-icon">
                {whyChooseImage2 ? (
                  <img 
                    src={whyChooseImage2} 
                    alt="Reliable Service" 
                    className="why-feature-icon-img"
                  />
                ) : (
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                    <rect x="45" y="45" width="35" height="20" rx="2" fill="#4a90e2"/>
                    <rect x="70" y="35" width="10" height="10" rx="1" fill="#4a90e2"/>
                    <circle cx="55" cy="65" r="5" fill="#333"/>
                    <circle cx="75" cy="65" r="5" fill="#333"/>
                    <path d="M40 45 L45 45 L45 55 L40 60 L25 60 L25 45 L40 45" fill="#4a90e2"/>
                    <circle cx="30" cy="30" r="12" fill="white" stroke="#4a90e2" strokeWidth="2"/>
                    <path d="M30 22 L30 30 L36 33" stroke="#4a90e2" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M20 50 L15 55 M85 50 L90 55 M20 40 L15 40 M85 40 L90 40" stroke="#4a90e2" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                )}
              </div>
              <h3 className="why-feature-title">Reliable Service</h3>
              <p className="why-feature-description">
                Our trained agents are standing by 24/7/365. Unlike many other emergency alarm companies, 
                we stay on the line until help arrives. Alert1 is a BBB Accredited Business with an A+ rating.
              </p>
              <div className="why-feature-bbb">
                <BBBSeal variant="badge" />
              </div>
            </div>
            
            <div className="why-feature-card">
              <div className="why-feature-icon">
                {whyChooseImage3 ? (
                  <img 
                    src={whyChooseImage3} 
                    alt="No Long Term Contracts" 
                    className="why-feature-icon-img"
                  />
                ) : (
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                    <rect x="30" y="20" width="40" height="55" rx="2" fill="white" stroke="#333" strokeWidth="2"/>
                    <path d="M40 30 L60 30 M40 40 L60 40 M40 50 L55 50" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="70" cy="60" r="15" fill="#4a90e2"/>
                    <path d="M63 53 L77 67 M77 53 L63 67" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                )}
              </div>
              <h3 className="why-feature-title">No Long Term Contracts</h3>
              <p className="why-feature-description">
                We offer flexible plan options. Pay monthly or in advance—the choice is yours! 
                No long-term contract required; cancel any time by returning the equipment.
              </p>
            </div>
          </div>
          
          <div className="why-choose-cta">
            <Link to="/medical-alerts" className="view-systems-btn">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog-section">
        <div className="container">
          <h2 className="blog-title">Latest News for Seniors from the Alert1 Blog</h2>
          
          <div className="blog-grid">
            <Link to="/blog/fall-prevention" className="blog-card">
              <div className="blog-image">
                {blogImage1 ? (
                  <img 
                    src={blogImage1} 
                    alt="Fall Prevention for Aging Parents" 
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f0f0f0' }}></div>
                )}
              </div>
              <h3 className="blog-card-title">Fall Prevention for Aging Parents: A Complete Guide</h3>
              <p className="blog-date">June 08, 2025</p>
              <button className="blog-read-more">READ MORE</button>
            </Link>
            
            <Link to="/blog/home-safety" className="blog-card">
              <div className="blog-image">
                {blogImage2 ? (
                  <img 
                    src={blogImage2} 
                    alt="Rethinking Home Safety for Aging Parents" 
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f0f0f0' }}></div>
                )}
              </div>
              <h3 className="blog-card-title">Rethinking Home Safety for Aging Parents</h3>
              <p className="blog-date">June 08, 2025</p>
              <button className="blog-read-more">READ MORE</button>
            </Link>
            
            <Link to="/blog/caregiver-payment" className="blog-card">
              <div className="blog-image">
                {blogImage3 ? (
                  <img 
                    src={blogImage3} 
                    alt="How Much Do Family Members Get Paid for Caregiving" 
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f0f0f0' }}></div>
                )}
                <div className="blog-image-overlay">You Can Get Paid for Caregiving</div>
              </div>
              <h3 className="blog-card-title">How Much Do Family Members Get Paid for Caregiving? Complete Guide to Caregiver Stipends</h3>
              <p className="blog-date">April 27, 2025</p>
              <p className="blog-excerpt">
                Did you know you might get paid for the caregiving of your parent or other 
                loved one? Local, state, and federal programs make this possible. Learn ...
              </p>
              <button className="blog-read-more">READ MORE</button>
            </Link>
          </div>
        </div>
      </section>

      {/* As Recommended By Section */}
      <section className="recommended-by-section">
        <div className="container">
          <h2 className="recommended-title">As recommended by:</h2>
          
          <div className="media-logos-grid">
            <div className="media-logo-row">
              {mediaLogo1 && (
                <div className="media-logo">
                  <img src={mediaLogo1} alt="ABC News" />
                </div>
              )}
              {mediaLogo2 && (
                <div className="media-logo">
                  <img src={mediaLogo2} alt="Good Morning America" />
                </div>
              )}
              {mediaLogo3 && (
                <div className="media-logo">
                  <img src={mediaLogo3} alt="Frontiers in Robotics and AI" />
                </div>
              )}
              {mediaLogo4 && (
                <div className="media-logo">
                  <img src={mediaLogo4} alt="Fox News Channel" />
                </div>
              )}
            </div>
            
            <div className="media-logo-row">
              {mediaLogo5 && (
                <div className="media-logo">
                  <img src={mediaLogo5} alt="The Florida Times-Union" />
                </div>
              )}
              {mediaLogo6 && (
                <div className="media-logo">
                  <img src={mediaLogo6} alt="Washington Business Journal" />
                </div>
              )}
              {mediaLogo7 && (
                <div className="media-logo">
                  <img src={mediaLogo7} alt="Los Angeles Times" />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default HomePage;
